import { lazy } from 'react';
import { redirect } from 'react-router';

const ClientsPage = lazy(() => import('./pages/clients'));
const ClientKpiPage = lazy(() => import('./pages/client-kpi'));
const TaxSettingPage = lazy(() => import('./pages/tax-setting'));
const TaxForm = lazy(() => import('./pages/tax-setting/form'));
const FeeSettingsPage = lazy(() => import('./pages/fee-settings'));
const ClientsModelsPage = lazy(() => import('./pages/clients-models'));
const ReportingPage = lazy(() => import('./pages/reporting'));
const FeatureFlagsPage = lazy(() => import('./pages/feature-flags'));
const InvoicesPage = lazy(() => import('./pages/invoices'));

/**
 * Superadmin Console routes. Rendered under `ConsoleLayout` (registered in
 * `src/routes/index.ts`).
 */
export const consoleRoute = [
  {
    path: '/console',
    loader: () => redirect('/console/clients'),
  },
  {
    path: '/console/clients',
    Component: ClientsPage,
  },
  {
    path: '/console/feature-flags',
    Component: FeatureFlagsPage,
  },
  {
    path: '/console/client-kpi',
    Component: ClientKpiPage,
  },
  {
    path: '/console/tax-setting',
    Component: TaxSettingPage,
  },
  {
    // Trailing slash kept so the page's relative `navigate('form')` lands here.
    path: '/console/tax-setting/form/',
    Component: TaxForm,
  },
  {
    path: '/console/tax-setting/form/:id',
    Component: TaxForm,
  },
  {
    path: '/console/administration-fee/fee-settings',
    Component: FeeSettingsPage,
  },
  {
    path: '/console/administration-fee/clients-models',
    Component: ClientsModelsPage,
  },
  {
    path: '/console/administration-fee/reporting',
    Component: ReportingPage,
  },
  {
    path: '/console/administration-fee/invoices',
    Component: InvoicesPage,
  },
];
